import React from "react";
import { Link } from "react-router-dom";

function About() {
  const pub = process.env.PUBLIC_URL || "";

  return (
    <div className="bg-secondary">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-3xl px-4 py-7 md:py-9">
          <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">
            Practical Experience. Integrated Thinking.
          </h1>
          <div className="mt-5 h-px w-12 bg-slate-300/90" aria-hidden="true" />
          <p className="mt-2.5 text-base text-slate-600 md:text-lg">
            Real estate, design, and construction insight — brought together to help clients make better
            residential property decisions.
          </p>
        </div>
      </header>

      <section className="bg-secondary py-8 md:py-10">
        <div className="mx-auto max-w-6xl px-4">
          <div className="grid grid-cols-1 items-center gap-7 md:grid-cols-12 md:gap-9">
            <div className="md:col-span-5">
              <div className="mx-auto w-full max-w-[380px] rounded-xl border border-slate-200 bg-white p-2 shadow-sm md:mx-0">
                <div className="overflow-hidden rounded-lg">
                  <img
                    src={`${pub}/images/Mark_1987_web_crop.jpg`}
                    alt="Mark Beattie"
                    className="h-auto w-full object-contain"
                    loading="eager"
                    decoding="async"
                  />
                </div>
              </div>
            </div>
            <div className="max-w-xl md:col-span-7">
              <h2 className="text-xl font-bold text-slate-900 md:text-2xl">Mark Beattie</h2>
              <p className="mt-1 text-slate-600">Realtor | Design &amp; Construction Consultant</p>
              <div className="mt-5 space-y-3.5 text-slate-700">
                <p>
                  Most professionals specialize in one part of the process — real estate, design, or
                  construction.
                </p>
                <p>
                  My background spans all three, allowing for more informed decisions at every stage of a
                  residential project.
                </p>
                <p>
                  I work with clients who want to approach property decisions with a broader perspective —
                  whether buying, planning, or building.
                </p>
              </div>
              <ul className="mt-3 list-disc space-y-1.5 pl-5 text-slate-600">
                <li>Residential buying and selling with renovation potential in mind</li>
                <li>Planning projects with real construction constraints considered early</li>
                <li>Reducing risk by aligning decisions across all stages</li>
              </ul>
              <p className="mt-5 text-base leading-relaxed text-slate-600">
                I typically work with homeowners and investors who want to make smarter decisions early — not
                fix problems later.
              </p>
            </div>
          </div>

          <div className="mt-5">
            <h3 className="text-lg font-bold text-slate-900 md:text-xl">Experience That Connects the Process</h3>
            <ul className="mt-2.5 list-disc space-y-1.5 pl-5 text-slate-600 md:space-y-1">
              <li>Active residential realtor in Calgary</li>
              <li>Background in residential construction and project execution</li>
              <li>Experience with planning, permits, and design coordination</li>
              <li>Condominium expertise (CCS certified)</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="border-t border-slate-200 bg-white py-8 md:py-10">
        <div className="mx-auto max-w-4xl px-4">
          <p className="text-xs uppercase tracking-wide text-slate-500">Why This Approach Matters</p>
          <h2 className="mt-2.5 text-xl font-bold text-slate-900 md:text-2xl">One Process. Fewer Disconnects.</h2>
          <div className="mt-5 max-w-2xl space-y-3 text-slate-600">
            <p>
              Most residential projects break down at the transitions between buying, planning, and
              construction.
            </p>
            <p>
              Keeping those stages connected leads to better decisions, fewer surprises, and stronger
              outcomes.
            </p>
          </div>
          <ul className="mt-5 list-disc space-y-1.5 pl-5 text-slate-600">
            <li>One point of accountability across stages</li>
            <li>Better decisions earlier in the process</li>
            <li>Reduced redesign and rework</li>
            <li>Clear path from acquisition to execution</li>
          </ul>
        </div>
      </section>

      <section className="border-t border-slate-200/70 bg-white pb-10 pt-12 md:pb-12 md:pt-14">
        <div className="container mx-auto max-w-3xl px-4 text-center">
          <h2 className="text-xl font-bold tracking-tight text-slate-900 md:text-2xl">Start With a Conversation</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-slate-600 md:text-[15px]">
            Whether you are buying, planning, or building, we can help you approach your project with clarity
            from the start.
          </p>
          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <Link
              to="/contact"
              className="inline-flex min-h-[42px] w-full max-w-xs items-center justify-center rounded-md border border-slate-400/90 bg-slate-800 px-5 py-2.5 text-sm font-semibold leading-none text-white shadow-sm transition-all duration-200 hover:-translate-y-px hover:border-slate-500 hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400 sm:w-auto"
            >
              Contact
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
